import React, { useEffect, useState, useMemo } from "react";
import {
  Button,
  Divider,
  Form,
  Input,
  message,
  Radio,
  Select,
  Spin,
  Tag,
} from "antd";
import PropTypes from "prop-types";
import {
  EntityStatus,
  formItemLayout,
  ServiceEntitlementActions,
  ServiceEntitlementProfile,
  tailItemLayout,
} from "../../Constants/Constants";
import { apiCallback } from "../../ApiHandlers/Common";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { selectFilterFunction } from "../../Constants/Utilities";
import { onFormSubmit } from "../../ApiHandlers/ServiceEntitlementApiHandlers";
import { convertDeviceModelListToDropdown } from "../../Helpers/DeviceModelHelpers";
import { convertServiceTierList } from "../../Helpers/ServiceTierHelpers";
import { DiscardWarning } from "../Common/DiscardWarning";
import { convertServiceOfferingListToDropdown } from "../../Helpers/ServiceOfferingHelpers";
import { BreadCrumbs } from "../Common/BreadCrumbs";

const getInitialValues = (record, serviceProviderRecord) => {
  const initialValues = {
    providerName: serviceProviderRecord?.name,
    status: EntityStatus.ACTIVE,
    profile: ServiceEntitlementProfile.labTest.value,
  };
  if (record) {
    initialValues.entitlementName = record.entitlementName;
    initialValues.deviceModel = record.modelNumber;
    initialValues.serviceTier = record.serviceTierName;
    initialValues.profile = record.profile;
    initialValues.status = record.status;
    initialValues.volume = record.volume;
  }
  return initialValues;
};
const getTitle = (action) => {
  switch (action) {
    case ServiceEntitlementActions.add:
      return "Add";
    case ServiceEntitlementActions.edit:
      return "Update";
    case ServiceEntitlementActions.view:
      return "View";
    default:
      return "";
  }
};
const ServiceEntitlementForm = (props) => {
  console.log("ServiceEntitlementForm", props);
  const {
    action,
    history,
    record,
    deviceModelApi,
    serviceOfferingApi,
    serviceProviderRecord,
    onActionClick,
  } = props;

  const title = useMemo(() => getTitle(action), [action]);
  const [initialValues, setInitialValues] = useState(
    getInitialValues(record, serviceProviderRecord)
  );

  const [form] = Form.useForm();
  const [processing, setProcessing] = useState(false);
  //model info
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedOffering, setSelectedOffering] = useState(null);
  //tier info
  const [tierDataLoading, setTierDataLoading] = useState(false);
  const [tierData, setTierData] = useState([]);
  //offering info
  const [offeringData, setofferingDataData] = useState([]);
  const [offeringDataLoading, setofferingDataLoading] = useState(false);
  // device info
  const [deviceModelData, setDeviceModelData] = useState([]);
  const [deviceModelDataLoading, setdeviceModelDataLoading] = useState(false);

  const isAddForm = props.action === ServiceEntitlementActions.add;
  const isViewForm = action === ServiceEntitlementActions.view;

  useEffect(() => {
    if (
      action === ServiceEntitlementActions.add ||
      action === ServiceEntitlementActions.edit
    ) {
      fetchDeviceModelData();
      fetchofferingData();
    }
  }, []);
  useEffect(() => {
    if (!!selectedModel && !!selectedOffering) {
      upadteServiceTierData();
    }
  }, [selectedModel, selectedOffering]);

  const fetchDeviceModelData = () => {
    console.log("fetchDeviceModelData...");
    setdeviceModelDataLoading(true);
    const errorCallback = (error) => {
      setdeviceModelDataLoading(false);
      message.error("Error fetching service list");
    };
    const successCallback = (data) => {
      console.log("fetchDeviceModelList data", data);
      const deviceModelData = convertDeviceModelListToDropdown(data);
      setdeviceModelDataLoading(false);
      console.log("deviceModelData", deviceModelData);
      setDeviceModelData(deviceModelData);
    };
    try {
      deviceModelApi.getDeviceModels(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  };

  const fetchofferingData = () => {
    console.log("fetchofferingData...");
    setofferingDataLoading(true);
    const errorCallback = (error) => {
      setofferingDataLoading(false);
      message.error("Error fetching Provider list");
    };
    const successCallback = (data) => {
      console.log("fetchproviderList data", data);
      const offeringData = convertServiceOfferingListToDropdown(data);
      setofferingDataLoading(false);
      setofferingDataData(offeringData);
    };
    try {
      serviceOfferingApi.getAllServiceOfferings(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  };

  const upadteServiceTierData = () => {
    console.log("upadteServiceTierData...");
    const { history, serviceTierApi } = props;
    setTierDataLoading(true);
    const errorCallback = () => {
      setTierDataLoading(false);
      message.error("Error fetching Service Tier list");
    };
    const successCallback = (data) => {
      const tierData = convertServiceTierList(data);
      console.log("upadteServiceTierData data", tierData);
      setTierDataLoading(false);
      setTierData(tierData);
    };
    try {
      serviceTierApi.getServiceTierByOfferModel(
        selectedOffering,
        selectedModel,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  };

  const getTierPlaceholder = () => {
    return !selectedModel
      ? "Select Device Model to view Tier list!"
      : !selectedOffering
      ? "Select Offering to view Tier list!"
      : tierDataLoading
      ? "Loading Service Tier list..."
      : "Select Service Tier";
  };
  const onBackClick = () => {
    const isChanged =
      action === ServiceEntitlementActions.view
        ? false
        : checkForInputChanges();
    DiscardWarning({ isChanged, onActionClick })();
  };

  const checkForInputChanges = () => {
    const fieldsToCheck = [
      "providerName",
      "entitlementName",
      "deviceModel",
      "serviceOffering",
      "serviceTier",
      "profile",
      "volume",
      "status",
    ];
    const values = form.getFieldsValue();
    let isInputsChanged = false;
    fieldsToCheck.every((f) => {
      if (
        values.hasOwnProperty(f) &&
        values[f] !== initialValues[f] &&
        (!!values[f] || !!initialValues[f])
      ) {
        isInputsChanged = true;
        return false;
      }
      return true;
    });
    return isInputsChanged;
  };

  return (
    <div className="list-container">
      <div className="page-header-container">
        <BreadCrumbs
          headers={props.parentBread.concat(`${title} Service Entitlement`)}
          onParentActionClick={onBackClick}
        />
      </div>
      <Divider className="divider" />
      <div className="form-data-container">
        <fieldset disabled={isViewForm}>
          <Form
            form={form}
            name="service-entitlement-form"
            layout="horizontal"
            onFinish={onFormSubmit({ props, setProcessing, setInitialValues })}
            initialValues={initialValues}
            requiredMark={"optional"}
            size={"middle"}
            {...formItemLayout}
          >
            <Spin spinning={processing} tip={"Processing, please wait..."}>
              <Form.Item
                name="providerName"
                label="Service Provider Name"
                rules={[{ required: true }]}
              >
                <Input disabled style={{ width: "90%", maxWidth: "250px" }} />
              </Form.Item>
              <Form.Item
                name="entitlementName"
                label="Entitlement Name"
                rules={[
                  { required: true, message: "Please fill in this field" },
                ]}
              >
                <Input
                  title="Name should be unique"
                  style={{ width: "90%", maxWidth: "300px" }}
                  disabled={!isAddForm}
                />
              </Form.Item>
              <Form.Item
                name="deviceModel"
                label="Device Model:"
                rules={[
                  {
                    required: true,
                    message: "Please select Device Model(s)",
                  },
                ]}
              >
                {!isAddForm ? (
                  <Input disabled style={{ width: "90%", maxWidth: "250px" }} />
                ) : (
                  <Select
                    showSearch
                    allowClear
                    style={{ width: "90%", maxWidth: "250px" }}
                    loading={deviceModelDataLoading}
                    disabled={deviceModelDataLoading}
                    onChange={(id) => setSelectedModel(id)}
                    filterOption={selectFilterFunction}
                    placeholder={
                      deviceModelDataLoading
                        ? "Loading Device Model list..."
                        : "Select any Device Model"
                    }
                  >
                    {deviceModelData.map((item) => (
                      <Select.Option
                        key={item.modelId}
                        title={item.modelNumber}
                      >
                        {item.modelNumber}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              {isAddForm && (
                <Form.Item
                  name="serviceOffering"
                  label="Service Offering"
                  rules={[
                    {
                      required: true,
                      message: "Please select Service Offering",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    allowClear
                    style={{ width: "90%", maxWidth: "300px" }}
                    loading={props.offeringDataLoading}
                    disabled={props.offeringDataLoading}
                    onChange={(id) => setSelectedOffering(id)}
                    filterOption={selectFilterFunction}
                    placeholder={
                      props.offeringDataLoading
                        ? "Loading Service Offerings..."
                        : "Select Service Offerings"
                    }
                  >
                    {offeringData.map((item) => (
                      <Select.Option
                        key={item.offerId}
                        title={item.offeringName}
                      >
                        {item.offeringName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
              <Form.Item
                name="serviceTier"
                label="Service Tier"
                rules={[
                  {
                    required: true,
                    message: "Please select Service Tier",
                  },
                ]}
              >
                {!isAddForm ? (
                  <Input disabled style={{ width: "90%", maxWidth: "300px" }} />
                ) : (
                  <Select
                    showSearch
                    allowClear
                    style={{ width: "90%", maxWidth: "300px" }}
                    loading={tierDataLoading}
                    filterOption={selectFilterFunction}
                    disabled={
                      tierDataLoading || !selectedModel || !selectedOffering
                    }
                    placeholder={getTierPlaceholder()}
                  >
                    {tierData?.map((item) => (
                      <Select.Option
                        key={item.serviceTierId}
                        title={item.serviceTierName}
                      >
                        {item.serviceTierName}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item
                name="profile"
                label="Profile"
                rules={[{ required: true }]}
              >
                {isViewForm ? (
                  <Tag>{initialValues.profile}</Tag>
                ) : (
                  <Radio.Group
                    options={Object.values(ServiceEntitlementProfile)}
                    value={initialValues.profile}
                  />
                )}
              </Form.Item>
              <Form.Item name="volume" label="Volume">
                <Input
                  type="number"
                  min="0"
                  step="1"
                  style={{ maxWidth: "100px" }}
                />
              </Form.Item>
              <Form.Item
                name="status"
                label="Status"
                rules={[{ required: true }]}
              >
                <Tag
                  color={
                    initialValues.status === EntityStatus.ACTIVE
                      ? "green"
                      : "red"
                  }
                >
                  {initialValues.status}
                </Tag>
              </Form.Item>
              {!isViewForm && (
                <Form.Item {...tailItemLayout}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="submit-button"
                  >
                    {title}
                  </Button>
                  <Button
                    htmlType="button"
                    onClick={() => form.resetFields()}
                    className="cancel-button"
                  >
                    Cancel
                  </Button>
                </Form.Item>
              )}
            </Spin>
          </Form>
        </fieldset>
      </div>
    </div>
  );
};

ServiceEntitlementForm.propTypes = {
  serviceProviderRecord: PropTypes.object,
  action: PropTypes.string,
  record: PropTypes.object,
  onSubmit: PropTypes.func,
  onActionClick: PropTypes.func,
  parentBread: PropTypes.array,

  deviceModelApi: PropTypes.object,
  serviceOfferingApi: PropTypes.object,
  serviceTierApi: PropTypes.object,
  serviceEntitlementApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  deviceModelApi: state.apis.deviceModelApi,
  serviceOfferingApi: state.apis.serviceOfferingApi,
  serviceTierApi: state.apis.serviceTierApi,
  serviceEntitlementApi: state.apis.serviceEntitlementApi,
});
const connectedServiceEntitlementForm = connect(mapStateToProps)(
  ServiceEntitlementForm
);
export default withRouter(connectedServiceEntitlementForm);
